import { Button, Flex, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TRY, useCreateCampaignStepsContext } from '../campaign-create-steps-context'
import { Title } from '../title'
import { CandidateAttributes } from '../../../../candidate/components/candidate-attributes'
import clsx from 'clsx'

export function FinishStep() {
    const { t } = useTranslation()
    const { currentStep, match, improve, nextStep } = useCreateCampaignStepsContext()

    return (
        <div className={clsx({ hidden: currentStep !== TRY })}>
            <Title>{t('Test conversation')}</Title>
            <Flex
                vertical
                gap={40}
            >
                <div className="text-center">
                    <Typography.Title>{(match?.matchScore || 0) >= 70 ? '🏆' : '😐'}</Typography.Title>
                    <Typography.Title
                        level={2}
                        className="m-0"
                    >
                        {match?.matchScore}%
                    </Typography.Title>
                </div>
                <CandidateAttributes
                    positive={match?.positiveCandidateAttributes}
                    negative={match?.negativeCandidateAttributes}
                />
                <Flex
                    gap="large"
                    justify="space-between"
                >
                    <Button
                        size="large"
                        onClick={() => improve()}
                    >
                        {t('Adjust conversation')}
                    </Button>
                    <Button
                        size="large"
                        type="primary"
                        onClick={() => nextStep()}
                    >
                        {t('Continue')}
                    </Button>
                </Flex>
            </Flex>
        </div>
    )
}
